import React from 'react';
import ListBox from 'carbon-components-react/lib/components/ListBox';

const ResultsBox: React.FC<Props> = ({
  items = [],
  onItemClick,
  itemToLabel
}) => {
  return (
    <div className={`bx--list-box__wrapper`}>
      <ListBox className="bx--combo-box" isOpen={true}>
        <ListBox.Menu
          id="address-search-list-menu"
          className="address-search-list-menu"
        >
          {items.map((item: any, inx: number) => {
            return (
              <ListBox.MenuItem
                key={inx}
                onClick={() =>
                  typeof onItemClick === 'function' && onItemClick(item)
                }
              >
                {typeof itemToLabel === 'function'
                  ? itemToLabel(item)
                  : item?.label}
              </ListBox.MenuItem>
            );
          })}
        </ListBox.Menu>
      </ListBox>
    </div>
  );
};

type Props = {
  items: any[];
  onItemClick: Function;
  itemToLabel?: Function;
};

export default React.memo(ResultsBox);
